<template>
  <div class="items_like">
    <div class="gotit_block_top">
      <div class="gotit_block_title">
        Recommended Items
      </div>
      <div @click.stop="showRecommendedItems()" class="gotit_block_more">
        See All
      </div>
    </div>
    <div @scroll="onScroll" class="like_items_grid">
      <div v-for="item in response" :key="item.id" @click="showItem(item.id)" class="pointer">
        <!--<img v-lazy-load :data-src="(item.itemPhotoThumbnail || item.image).replace('https://res.cloudinary.com/gotit/image/upload/q_auto:eco,f_auto/map/', 'https://d1m6665y17lo66.cloudfront.net/')">-->
        <img v-lazy-load :data-src="item.itemPhotoThumbnail || item.image">
      </div>
      <template v-if="response.length === 0 || loading">
        <div v-for="item in emptyItems" :key="item" class="animated-backgroundd" />
      </template>
    </div>
  </div>
</template>
<script>
import utils from '~/mixins/utils'

export default {
  name: 'RecommendedItems',
  mixins: [utils],
  data () {
    return {
      response: [],
      emptyItems: [1, 2, 3, 4, 5, 6],
      skipCounter: 0,
      noMoreScroll: false,
      loading: true,
      params: {
        endpoint: '/items/select',
        filter: 'WANTED',
        filterParam: 25, // Recommended
        skip: 0,
        limit: 20,
        includeProperties: true,
        cache: true
      }
    }
  },
  mounted () {
    this.$store.dispatch('api/genericCall', this.params).then((response) => {
      this.response = response
      this.loading = false
    }).catch()
  },
  methods: {
    async onScroll (
      {
        target: { scrollTop, clientHeight, scrollHeight }
      }) {
      if (!this.noMoreScroll && (scrollTop + clientHeight >= scrollHeight) && !this.loading) {
        this.loading = true
        this.skipCounter++
        this.params.skip = this.params.limit * this.skipCounter

        const response = await this.$store.dispatch('api/genericCall', this.params)
        if (response.length === 0) {
          this.noMoreScroll = true
          this.loading = false
        } else {
          if (response.length < this.limit) {
            this.noMoreScroll = true
          }
          this.response = this.response.concat(response)
          setTimeout(() => {
            this.loading = false
          }, 1000)
        }
      }
    },
    showItem (itemId) {
      this.addItemDetailsToEventsLayer('select_item', itemId)
      this.$emit('navigate', '/items/' + this.encrypt(itemId))
    },
    showRecommendedItems () {
      // 25 === recommended
      this.$emit('navigate', '/search?category=25')
    }
  }
}
</script>
<style scoped>
  .items_like h3 {
    margin-bottom: 1.2em;
  }

  .like_items_grid {
    height: calc(78px * 2 + 5px);
    overflow-y: scroll;
    display: grid;
    grid-template-columns: repeat(3, 78px);
    grid-gap: 5px;
    grid-auto-rows: 1fr;
  }

  .like_items_grid::before {
    content: '';
    width: 0;
    padding-bottom: 100%;
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }

  .like_items_grid > *:first-child {
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }

  .like_items_grid > * {
    background: rgba(0, 0, 0, 0.1);
    border: 1px white solid;
  }

  .animated-backgroundd {
    animation-duration: 7s !important;
    animation-fill-mode: forwards !important;
    animation-iteration-count: infinite !important;
    animation-name: placeHolderShimmer !important;
    animation-timing-function: linear !important;
    background: #f6f7f8 !important;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%) !important;
    position: relative;
    height: 78px;
  }

  .gotit_block_top {
    margin-bottom: 1em;
  }

</style>
